module.exports = __webpack_public_path__ + "static/img/wlzq.26b6fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wlzq.png
// module id = yfxT
// module chunks = 4